module.exports = __webpack_public_path__ + "img/ImageQresult3.852ea7a2.png";